var map = {
	"./App/index.tsx": 680,
	"./AuthenticityCheck/index.tsx": 315,
	"./CounterfeitReport/index.tsx": 681,
	"./TecDoc/index.tsx": 61,
	"./TecRMI/index.tsx": 682,
	"./User/index.tsx": 314,
	"./ValueAddedService/index.tsx": 683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 479;